<template>
<div>
     <v-progress-linear indeterminate  color="primary" v-if="loaders.detail_loader"></v-progress-linear>
    <v-container fluid grid-list-md class="dashboard">
        <v-layout row wrap>
            <v-flex xs12>
                <v-snackbar
                    v-model="alert" 
                    color="green lighten-2" 
                    class="white--text" 
                    top outlined dense 
                    type="success" text>
                    {{ message }}
                    <v-btn color="white" text  @click="alert = false">  <v-icon color="maroon">mdi-close</v-icon></v-btn>
                </v-snackbar>
                 <v-snackbar
                    v-model="alert_error" 
                    color="red lighten-2" 
                    class="white--text" 
                    top outlined dense
                    type="error" text>
                    {{ error }}
                    <v-btn color="white"  text  @click="alert_error = false"> Close</v-btn>
                </v-snackbar>
           </v-flex>
            <v-flex xs12 sm12 md5>
                <v-card outlined class="pa-2" height="100%">
                    <div>  
                        <v-layout row wrap fill-height class="light-bg pa-2">
                            <v-flex>
                                <p class="text-color pb-0">Office Details</p>
                            </v-flex>
                            <v-flex>
                                <v-btn small color="primary" class="ml-3 float_right" :to="`/profileEdit/${office_details.id}`">Edit</v-btn>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout row wrap fill-height class="innerheader">
                            <v-flex xs12>
                                <v-layout row wrap>
                                    <v-list-item dense>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Name</v-list-item-subtitle>
                                            <v-list-item-title v-if="office_details.name!=null" class="pt-1">{{office_details.name |capitalize}}</v-list-item-title>
                                            <v-list-item-title v-else="" three-line wrap="true" class="pt-1">-</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item dense>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Unit No</v-list-item-subtitle>
                                            <v-list-item-title v-if="office_details.unit_no!=null" three-line wrap="true" class="pt-1">{{office_details.unit_no}}</v-list-item-title>
                                            <v-list-item-title v-else="" three-line wrap="true" class="pt-1">-</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                     <v-list-item dense>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Email ID</v-list-item-subtitle>
                                            <v-list-item-title  v-if="office_details.email!=null"  three-line wrap="true" class="pt-1">{{office_details.email}}</v-list-item-title>
                                            <v-list-item-title v-else="" three-line wrap="true" class="pt-1">-</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item dense>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Address</v-list-item-subtitle>
                                            <v-list-item-title three-line wrap="true" class="pt-1">{{office_details.address| capitalize}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item dense>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Wing</v-list-item-subtitle>
                                            <v-list-item-title three-line wrap="true" class="pt-1">{{office_details.wing.name}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item dense>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Created At</v-list-item-subtitle>
                                            <v-list-item-title three-line wrap="true" class="pt-1">{{formatDate(office_details.created_at)}}</v-list-item-title>
                                        </v-list-item-content>
                                        
                                    </v-list-item>
                                    <v-list-item dense>
                                       
                                         <v-list-item-content>
                                            <v-list-item-subtitle>Updated At</v-list-item-subtitle>
                                            <v-list-item-title three-line wrap="true" class="pt-1">{{formatDate(office_details.updated_at)}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card>
            </v-flex>
            <v-flex xs12 sm12 md7>
                <v-card outlined class="pa-2" height="100%">
                    <div>
                        <v-layout row wrap fill-height class="light-bg pa-2">
                            <v-flex>
                                <p class="text-color">Admins</p>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout row wrap fill-height class="innerheader">
                            <v-flex xs12>
                                <v-data-table 
                                :headers="user_headers" 
                                :items="office_related_users" 
                                item-key="id" 
                                class="elevation-1" 
                                :loading="loaders.detail_loader"
                                :footer-props="{'items-per-page-options': [5,10,20,40]}"
                                :items-per-page="5">
                                    <template v-slot:body="{ items }"  v-if="!loaders.detail_loader && count!='0'">
                                        <tbody>
                                            <tr v-for="item in items" :key="item.name">
                                                <td>
                                                   {{ item.username }}
                                                </td>
                                                
                                                <td>
                                                
                                                    <v-btn text color='blue' small @click="Update_password(item)">
                                                        Change Password
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                <template v-slot:loading> Loading... Please wait </template>
                                <template v-slot:no-results> No data available </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>

  
    <!-- Delete user model -->
    <v-dialog v-model="change_password_dialog_box" scrollable :overlay="false" max-width="600px" transition="dialog-transition">
        <v-card>
             <v-progress-linear
                        :active="loaders.submit_loader"
                        :indeterminate="loaders.submit_loader"
                        absolute
             ></v-progress-linear>
            <v-form>
               <v-card-text class="pl-5">
                  <h3>Update Password</h3>
                </v-card-text>
                <v-card-actions class='pa-5'>
                      <v-layout row wrap>
                            <v-flex sm12 md12>
                                <v-form id="updatepassword"
                                 @submit.prevent="updatepassword" 
                                 data-vv-scope="updatepassword"
                                 autocomplete="off"
                                  ref="updatepassword">
                                    <v-card-text>
                                        <v-container fluid grid-list-md >
                                            <v-layout row wrap>
                                                <v-flex xs6>
                                                    <v-text-field 
                                                    name="Old Password" 
                                                    label="Old Password" 
                                                    id="Old Password" 
                                                    v-model="user_object.oldpassword">
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs6>
                                                    <v-text-field 
                                                    name="New Password" 
                                                    label="New Password" 
                                                    id="New Password" 
                                                    v-model="user_object.newpassword">
                                                    </v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" small  type="submit">Update</v-btn>
                                         <v-btn text small @click="canclePasswordChange()">Cancel</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-flex>
                        </v-layout>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
export default {
    watch: {
        "user_search": {
            handler(val) {
                if (val) {
                    if (val.length >= 3) {
                        this.search_message = "";
                        this.getUserList();
                    }
                } else {
                    this.search_message = "Enter atleast 3 characters";
                }

            }
        },
    },
    methods: {
        getOfficeDetails: function () {
            this.loaders.detail_loader = true;
            axios.get(`${process.env.VUE_APP_API_URL}/api/offices/` + this.office.office_id).then(response => {
                  
                   if (response.data.status == 1) {
                        this.office_details = response.data.office_details;
                        this.office_related_users = response.data.office_details.users;
                       

                        this.loaders.detail_loader = false;
                    }if (response.data.status == 0) {
                        this.alert_error=true;
                        this.error = "Error Ocurred - Unable to get Office details"
                        this.loaders.detail_loader = false;
                    }
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {

                });
        },
        getUserList: function () {
            this.loaders.detail_loader = true;
            axios.get(`${process.env.VUE_APP_API_URL}/api/users/list`, {
                params: {
                    query_string: this.user_search
                }
            }).then((response) => {
                if (response.data.status == 1) {
                    this.users = response.data.user_list;
                    this.count = response.data.user_list.count;
                    this.loaders.detail_loader = false;

                }if (response.data.status == 0) {
                        this.alert_error=true;
                        this.error = "Error Ocurred - Unable to get User details";
                    }
            }).catch((error) => {
                console.log(error);

            }).finally(() => {
                {

                }
            });

        },
        updatepassword() {
            this.loaders.submit_loader = true;
            this.user_object.id =  this.change_password_of_user.id
            
            axios.post(`${process.env.VUE_APP_API_URL}/api/users/` + this.$route.params.id + `/update`, this.user_object).then((response) => {
               
                if (response.data.status == 1) { 
                     this.loaders.submit_loader = false;
                     this.canclePasswordChange();
                     this.alert=true;
                     this.message = response.data.message;
                }
                if(response.data.status == 0){
                   
                    this.canclePasswordChange();
                    this.alert_error=true;
                    this.error = response.data.message;
                }
            }).catch((error) => {
                console.log(error);
            }).finally(() => {

            });
        },
        
        Update_password(user) {
            this.change_password_of_user = user;
            this.change_password_dialog_box = true;
        },
        canclePasswordChange(){
            this.user_object.oldpassword='';
            this.user_object.newpassword='';
            this.change_password_dialog_box = false;
        }
       
    },
    data() {
        return {
           
            image: require('@/assets/images/building.png'),
            office_details: { wing:{}},
            count:'',
             user_object: {
                id:'',
                oldpassword: '',
                newpassword: '',
            },
            loaders: {
                detail_loader: false,
                submit_loader: false,
            },
            error: '',
            success:'',
            loading:'',
            delete_office_dialog_box: false,
            change_password_dialog_box: false,
            office_related_users: [],
            visit_headers: [{
                    text: 'Image',
                    align: 'left',
                    value: 'image',
                },
                {
                    text: 'Visitor',
                    value: 'visitor_id',
                    sortable: false,
                },
                {
                    text: 'Type',
                    value: 'type'
                },
                {
                    text: 'Time',
                    value: 'time'
                },
                {
                    text: 'Office',
                    value: 'office_id',
                    sortable: false
                },
                {
                    text: 'Action',
                    value: '',
                    sortable: false
                }
            ],
            user_headers: [{
                    text: 'User Name',
                    align: 'left',
                    value: 'username',
                },
                  
                {
                    text: 'Action',
                    value: '',
                    sortable: false
                }
               
            ],
            search_user: "",
            is_loading: false,
            search_message: "Enter atleast 3 characters",
            users: [],
            total_items: 10,
            options: {},
            message:'',
            alert: false,
            alert_error:false,
            office:'',
        }
    },
    mounted() {
         if(this.$route.params.success_message!=null) 
        {    this.alert=true;
            this.message = this.$route.params.success_message;
        }
        this.office = JSON.parse(localStorage.getItem('visitor_management_user'))
        this.getOfficeDetails();
    }
};
</script>
